import EntryGrid from "@/components/EntryGrid";
import clsx from "clsx";

const CreatorContent = ({ recipes }) => {
  return (
    <div className={clsx("CreatorContent")}>
      <div
        className={clsx(
          "CreatorContent__searchHits",
          "px-6 py-6 lg:px-12 lg:pb-12 lg:pt-6"
        )}
      >
        {recipes?.length > 0 && (
          <div className={clsx("py-6")}>
            <EntryGrid entries={recipes} />
          </div>
        )}
      </div>
    </div>
  );
};

export default CreatorContent;
